import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";

type PolicyTextProps = {
    className?: string;
};

export default function PolicyText({ className }: PolicyTextProps): JSX.Element {
    const privacyPolicyLinkProps = `href=${environment.get(
        "urlPatterns.helpPrivacyPolicy"
    )} target="_blank"`;
    const termsAndConditionsLinkProps = `href=${environment.get(
        "urlPatterns.helpTermsAndConditions"
    )} target="_blank"`;

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{
                // "By creating an account, you consent to Lyst’s Terms & Conditions.
                // To learn more about how Lyst uses and protects your personal data, please read Lyst’s Privacy Policy."
                __html: gettext("account.register.legal_agreement.sign_up_opt_in_terms", {
                    terms_and_conditions_link_props: termsAndConditionsLinkProps,
                    privacy_policy_link_props: privacyPolicyLinkProps,
                }),
            }}
        />
    );
}
